<template>
  <div class="activity-shop-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="活动商家详情" :showBack="true"></my-header>
    <div class="shop-detail general-box-shadow">
      <div class="shop-info">
        <div class="field-name">店铺名称：</div><div class="field-value">{{dealerShop.name}}</div>
      </div>
      <div class="shop-info">
        <div class="field-name">联系电话：</div><div class="field-value">{{dealerShop.phone}}</div>
      </div>
      <div class="shop-info">
        <div class="field-name">商家简介：</div><div class="field-value">{{dealerShop.intro}}</div>
      </div>
    </div>
    <div @click="goPayDeposit" class="pay-deposit">付订金</div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import shopService from '../../service/shop/ShopService'
  import activityService from '../../service/activity/ActivityService'
  import {imgUrl,shareIcon} from "../../config";
  import appTools from '../../utils/Tools'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'ActivityShop',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        shopId:'',
        dealerShop:{},
        pageNo:1,
        productList:[],
        activity:{},
        showTip:false,
        tipMsg:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isActivityStart:false
      }
    },
    created(){
      this.shopId = this.$route.query.shopId;
      this.activityId = this.$route.query.activityId
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.activityId) {
        this.activityId = this.global.activityId;
        this.global.activityId = '';
      }
      if(this.global.shopId){
        this.shopId = this.global.shopId;
        this.global.shopId = '';
      }
      this.loadShopDetail();
      this.loadActivityDetail();
      this.initWechatShare();
    },
    methods: {
      async loadShopDetail(){
        let {code,msg,data} = await shopService.detail(this.shopId);
        if(code == '0'){
          this.dealerShop = data.shop;
        }else {
          Toast(msg);
        }
      },
      async loadActivityDetail(){
        let {code,msg,data} = await activityService.detail(this.activityId);
        if(code == '0'){
          this.activity = data;
          let startTime = appTools.parseDate(this.activity.startTime);
          let now = new Date();
          this.isActivityStart = now > startTime;
        }else {
          Toast(msg);
        }
      },
      confirm(){
        this.showTip = false;
      },
      toActivityProduct(activityProductId){
        this.global.activityId = this.activityId;
        this.global.shopId = this.shopId;
        this.$router.push({name: 'ActivityProduct', query: {activityProductId,shopId:this.shopId,activityId:this.activityId}})
      },
      //对商家付订金
      goPayDeposit(){
        let startTime = appTools.parseDate(this.activity.startTime);
        let endTime = appTools.parseDate(this.activity.endTime);
        let now = new Date();
        if(now.getTime() < startTime.getTime()){
          this.showTip = true;
          this.tipMsg = '该活动还未开始!';
        }else if(startTime.getTime() <= now.getTime() && now.getTime() < endTime.getTime()){
          if(this.dealerShop.depositSwitch != '1'){
            Toast('暂时不能对该店铺付订金!');
          } else {
            this.global.activityId = this.activityId;
            this.global.shopId = this.shopId;
            this.$router.push({name: 'OfflineDeposit', query: {shopId:this.shopId,type:'2'}})
          }
        }else {
          this.showTip = true;
          this.tipMsg = '该活动已结束!';
        }
        Toast(this.tipMsg);
      },
      async initWechatShare(){
        let title = "活动店铺";// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#')
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-shop-page{
    height: 100vh;
    padding-top: 0.3rem;
    font-size: 0.32rem;
    background-color: white;
    .shop-detail{
      width: 6.90rem;
      margin: 0 auto;
      padding: 0.3rem 0;
      .shop-info{
        display: flex;
        line-height: 0.5rem;
        padding-left: 0.2rem;
        .field-name{
          width: 1.6rem;
          font-size: 0.28rem;
          color: #7f7d7c;
        }
        .field-value{
          width: 5.5rem;
        }
      }
    }
    .pay-deposit{
      position: fixed;
      bottom: 0.6rem;
      left: 2.35rem;
      width: 2.8rem;
      line-height: 0.8rem;
      margin: 0 auto;
      border-radius: 0.8rem;
      background-color: #feac00;
      text-align: center;
      color: white;
    }
  }
</style>
